import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    RouterStateSnapshot,
} from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { ConsoleLogService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable, of } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { UserAuthService } from './user-auth.service';

export const rideCommandAuthGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean> => {
    const configService = inject(ConfigService);
    const consoleLogService = inject(ConsoleLogService);
    const userAuthService = inject(UserAuthService);

    const skipAuthIfOnRoad = route.data.skipAuthIfOnRoad as boolean;

    if (skipAuthIfOnRoad && configService.isOnRoad) {
        return of(true);
    }

    return userAuthService.isAuthenticated$.pipe(
        take(1),
        tap((authenticated) => {
            if (!authenticated) {
                consoleLogService.debug('redirect for no auth');
                // temporary fix until combineUrl dedupes culture codes
                userAuthService.promptAuthenticationAndNavigate(
                    `${configService.isEpi ? '/app' : ''}${state.url}`
                );
            }
        })
    );
};
